export const primaryBackground = "#F4F4F9";
export const primaryGrey = "#f8f8f8";
export const primaryBlue = "#5A5E9D";
export const primaryPink = "#F4B3D1";
export const primaryColor = "#060A28";
export const primaryGreen = "#3fa15e";
export const primaryLightBlue = "#A6ACC3";
export const deleteRed = "#ED5E68";
export const deleteRed2 = "#F9320D";
